import {Container} from '@inlet/react-pixi';
import React from 'react';
import {ButtonWithIcon} from '@gongxigames/framework/core/fragments/react/components/ButtonWithIcon';

type Icon = {
    up: string;
    down?: string;
    over?: string;
    disabled?: string;
};

export type ToggleWithIconProps = {
    onToggle: (value: boolean) => void;
    disabled?: boolean;
    visible?: boolean;
    name?: string;
    x?: number;
    y?: number;
    offIcon: Icon;
    onIcon: Icon;
    value: boolean | null;
};

export class ToggleButtonWithIcon extends React.Component<ToggleWithIconProps> {
    protected onToggle(): void {
        this.props.onToggle(!this.props.value);
    }

    public render(): JSX.Element {
        const {
            onIcon,
            offIcon,
            disabled,
            value,
            name = 'ToggleButtonWithIcon',
            ...containerProps
        } = this.props;

        const icon = value ? onIcon : offIcon;

        return (
            <Container name={name} {...containerProps}>
                <ButtonWithIcon
                    disabled={disabled}
                    icon={icon}
                    onClick={this.onToggle.bind(this)}
                />
            </Container>
        );
    }
}
